<template>
  <v-container class="no-margins">

    <div class="v-step-0 v-step-1 v-step-2 v-step-12 v-step-21 v-step-27">
      <h1>{{ $t("welcome.hello") }} {{ currentUser.firstName }}!</h1>
      <h6 v-if="isApprentice" class="mt-n4 mb-6 subtitle-2">{{ subTitle }}</h6>
    </div>

    <template v-if="shouldReadInstructions && isInstructor(0)">
      <MessageBox class="my-6" type="warning">
        <h6>{{ $t("settings.no-readInstructions-mb-title") }}</h6>
        <p v-html="$t('settings.no-readInstructions-mb-text')"></p>
    </MessageBox>
    </template>
    <!-- <div v-if="basicsIsLoaded && (isInstructor(0) || isApprentice)"> -->
    <MessageBox type="alert" class="mb-8" v-if="showOrderWarning && (isDistanceEducationAdministrator(0) ||
                  isDepartmentAdministrator(0) || isAdministrator)">
      <h5>{{ $t("order.info.daysWarning-title") }}</h5>
        <p>
          {{ $t("order.info.daysWarning-text2") }}
        </p>
    </MessageBox>

    <Byn2Import />

    <div class="mb-4 pb-4"></div>

    <div class="d-flex align-start justify-space-between">
      <div class="flex-item mr-8">
        <div v-if="filteredInstructorOptions.length">
          <h4 class="subtitle-2 mb-8">{{ $t("welcome.sub-title3") }}</h4>
        </div>

        <v-list class="ml-4 flex-1">
          <v-list-item
            v-for="(item, index) in actionItems"
            :key="`action-${index}`"
            @click="item.action"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
    
            <v-list-item-content>
              <v-list-item-title>
                {{ item.label }}
              </v-list-item-title>
            </v-list-item-content>
    
            <v-list-item-icon class="ml-auto">
              <v-icon size="10">$sl-arrow-right</v-icon>
            </v-list-item-icon>
    
            <v-badge
              v-if="item.badge"
              :content="item.badge"
              inline
              color="red"
            />
          </v-list-item>
        </v-list>
      </div>

      <div class="flex-item ml-8">
        <div v-if="filteredInstructorOptions.length && currentUser?.books?.length">
          <h4 class="subtitle-2 mb-8">{{ $t("labels.my-ebooks") }}</h4>
        </div>
        
        <EbookList
          v-if="isApprentice && !isInstructor(0) && currentUser.books.length > 0"
          :ebooks="currentUser.books"
          class="mb-4"
        />
      </div>
    </div>

    <template v-if="isInstructor(0)">
      <ButtonArray text="left" :options="filteredInstructorOptions" />
      <v-spacer class="pb-8"></v-spacer>
    </template>

    <template v-if="currentUser.books.length && isInstructor(0)==false && (isCompanyEducationResponsible(0) || isDistanceEducationAdministrator(0) || isAdministrator)">
      <ActionButton
        class="mt-4 left"
        actionIcon="$sl-ebook"
        @click="
          $nextTick(() => {
            $router.push({name: 'InstructorEbooks', params: {id: currentUser.id}})
          })
        "
        >{{ $t('labels.e-book') }}</ActionButton
      >
      <v-spacer class="pb-8"></v-spacer>
    </template>
    
    <template v-if="isCompanyUser(0)">
      <h4 class="pb-1 mt-10">{{ $t("labels.company-title") }}</h4>

      <v-expansion-panels :value="0" class="pb-0 mt-4">
        <v-expansion-panel v-for="(employment, i) in currentUser.employments" :key="i">
          <v-expansion-panel-header expand-icon="$sl-arrow-down">
            <div>
              <h5 class="subtitle-1">
                {{ employment.company ? employment.company.name : "Företaget" }}
              </h5>
              <span class="subtitle-2">{{
                employment.company.organizationalNumber | orgno
              }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mb-2">
            <div>
              <v-list
                v-for="(menuItem, itemIndex) in getCompanyMenuItems(employment)"
                :key="`company-${i}-item-${itemIndex}`"
                nav
                dense
              >
                <v-list-group
                  :ref="`listGroup-${i}-${itemIndex}`"
                  :prepend-icon="menuItem.icon"
                  no-action
                  class="pa-2"
                  v-model="menuItem.isOpen"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <div class="d-flex align-center justify-start">
                        <v-list-item-title class="ml-4">{{ menuItem.label }}</v-list-item-title>
                        
                        <v-badge
                          v-if="menuItem.badge && !menuItem.isOpen"
                          :value="menuItem.badge"
                          :content="menuItem.badge"
                          inline
                          color="black"
                          class="ma-0"
                          size="lg"
                        >
                        </v-badge>
                      </div>
                    </v-list-item-content>
                  </template>

                  <template v-for="(child, childIndex) in menuItem.children">

                    <v-list-group
                      v-if="child.subGroup"
                      :key="`subgroup-${itemIndex}-${childIndex}`"
                      :ref="`listGroup-${i}-${itemIndex}-${childIndex}`"
                      :prepend-icon="child.icon"
                      no-action
                      sub-group
                      class="ml-4"
                      v-model="menuItem.isOpen"
                    >
                      <template v-slot:activator>
                        <v-list-item-content>
                          <div class="d-flex align-center">
                            <v-list-item-title>{{ child.label }}</v-list-item-title>
                            
                            <v-badge
                              v-if="child.badge && !menuItem.isOpen"
                              :value="child.badge"
                              :content="child.badge"
                              inline
                              color="black"
                              class="mr-3"
                            >
                            </v-badge>
                          </div>
                        </v-list-item-content>
                      </template>

                      <v-list-item
                        v-for="(subChild, subChildIndex) in child.children"
                        :key="`subchild-${itemIndex}-${childIndex}-${subChildIndex}`"
                        :class="subChild.className"
                        class="px-3 py-1"
                      >
                        <ActionButton
                          :actionIcon="subChild.icon"
                          :badge="subChild.badge"
                          :class="['full-width-action-btn', subChild.tourClass]"
                          @click="$nextTick(() => $router.push(subChild.to).catch(() => {}))"
                        >
                          {{ subChild.label }}
                        </ActionButton>
                      </v-list-item>
                    </v-list-group>

                    <v-list-item
                      v-else
                      :key="`child-${itemIndex}-${childIndex}`"
                      :class="child.className"
                      class="px-3 py-1"
                    >
                      <ActionButton
                        :actionIcon="child.icon"
                        :badge="child.badge"
                        :class="['full-width-action-btn', child.tourClass]"
                        @click="child.onClick ? child.onClick() : $nextTick(() => $router.push(child.to).catch(() => {}))"
                      >
                        {{ child.label }}
                      </ActionButton>
                    </v-list-item>

                  </template>
                </v-list-group>
              </v-list>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <template v-if="
          isInstructor(0) == true ||
          isDepartmentAdministrator(0) == true ||
          isAdministrator == true ||
          isDistanceEducationAdministrator(0) == true ||
          isCompanyEducationResponsible(0) == true
        ">

      <p class="pt-6">
        {{ $t("welcome.information2") }}
      </p>

      <ActionButton
        class="pt-0 mt-4 mb-4 v-step-26"
        actionIcon="$sl-apprentice-application"
        @click="
          $nextTick(() => {
            $router.push({ name: 'ApplicationStart', params: { setStep: 0 } });
          })
        "
      >
        {{ $t("labels.own-application") }}
      </ActionButton>
    </template>

    <v-tour name="myTour" :steps="steps" :options="tourOptions">
      <template slot-scope="tour">
        <transition name="fade">
          <template v-for="(step, index) of tour.steps">
            <v-step
              v-if="tour.currentStep === index"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template>
                <div slot="actions" class="v-step__buttons">
                  <v-icon small @click="tour.stop" class="v-step__close">$sl-close</v-icon>

                  <button
                    v-if="tour.currentStep == 0"
                    @click="tour.stop"
                    class="v-step__button"
                  >
                    {{ $t("tour.stop") }}
                  </button>

                  <button
                    v-if="tour.currentStep > 0"
                    @click="onTourPrevious(tour)"
                    class="v-step__button"
                  >
                    {{ $t("tour.previous") }}
                  </button>

                  <button
                    v-if="tour.currentStep < tour.steps.length - 1"
                    @click="onTourNext(tour)"
                    class="v-step__button"
                  >
                    {{ $t("tour.next") }}
                  </button>

                  <button
                    v-if="tour.currentStep == tour.steps.length - 1"
                    @click="tour.stop"
                    class="v-step__button"
                  >
                    {{ $t("tour.stop") }}
                  </button>
                </div>
              </template>
            </v-step>
          </template>
        </transition>
      </template>
    </v-tour>

    <v-dialog persistent v-model="confirmPhoneModal" max-width="330px">
      <v-card flat>
        <v-icon class="close" @click.prevent="confirmPhoneModal=false">$sl-close</v-icon>
        <h2 class="mt-2 subtitle-2">{{ $t('dialog.confirm-modal', {phone: (currentUser.mobilephone) ? $options.filters.phoneNo(currentUser.mobilephone) : $t('dialog.missing'), email: (currentUser.email) ? currentUser.email: $t('dialog.missing')}) }}</h2>

        <v-card flat>
          {{ $t('dialog.confirm-modal-text') }}
        </v-card>

        <div class="d-flex align-center justify-end mt-8">
          <ActionButton
            :block="false"
            type="secondary"
            actionIcon="$sl-edit"
            @click="$nextTick(() => {
              $router.push({
                name: 'PersonAddress'
              })
            })"
          >{{ $t('labels.change') }}</ActionButton>
          
          <ActionButton
            :block="false"
            actionIcon="$sl-save"
            class="ml-2"
            @click="confirmPhone()"
          >{{$t('labels.yes')}}</ActionButton>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showRoleDialog" max-width="360px">
      <ChooseRole :roleList="roleList" @confirm="onRoleConfirm"/>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ActionButton from "@/components/Common/ActionButton";
import { CompanyRoles, InstructorAbilities } from "@/components/mixins";
import orderBy from 'lodash/orderBy'
import filter from "lodash/filter";
import uniqBy from "lodash/uniqBy";
import get from "lodash/get";
import API from "@/services/api.js";
import ButtonArray from "@/components/Common/ButtonArray";
import EbookList from "@/components/Common/Ebook/EbookList";
import Byn2Import from "@/components/Common/Byn2Import";
import groupBy from "lodash/groupBy";
import MessageBox from "@/components/Common/MessageBox";
import find from "lodash/find";
import ChooseRole from './ChooseRole';
import { bus } from '@/utils/bus'
import { getConsent, setConsent } from '@/utils/consent'

const SugarDate = require('sugar/date')

const AVAILABLE_ROLES_TOUR = {
  admin: 'admin',
  instructor: 'Instructor'
}

// @group Start
// LoggedIn component
export default {
  name: "LoggedIn",

  mixins: [CompanyRoles, InstructorAbilities],

  components: {
    ActionButton,
    ButtonArray,
    EbookList,
    MessageBox,
    Byn2Import,
    ChooseRole,
  },
  props: {
    guideStart: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      toApproveForCompany: {},
      confirmPhoneModal: false,
      shouldReadInstructions: false,
      currentUserId: null,
      toConfirm: [],
      firstTime: false,
      showOrderWarning: false,
      tourOptions: {
        useKeyboardNavigation: true,
        highlight: false,
        labels: {
          buttonNext: this.$t("tour.next"),
          buttonPrevious: this.$t("tour.previous"),
          buttonSkip: this.$t("tour.skip"),
          buttonStop: this.$t("tour.stop"),
        },
      },
      steps: [],
      companyApplicationTotal: null,
      roleList: [],
      showRoleDialog: false,
    };
  },
  filters: {
    orgno: function (value) {
      if (!value || value.length < 10) return "";

      return value.substring(0, 6) + "-" + value.substring(6, 10);
    },
  },
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isLoggedIn",
      "isRegistered",
      "isApprentice",
      "isCompanyUser",
      "isInstructor",
      "isAdministrator",
      "isCompanyEducationResponsible",
      "isDistanceEducationAdministrator",
      "isDepartmentAdministrator",
    ]),
    ...mapGetters("basic", [
      "toApproveByCompanyStatesId",
      "toConfirmByCompanyOrderStateId",
      "basicsIsLoaded",
    ]),

    subTitle(){
      if(!this.currentUser){
        return '';
      }

      const companyNames = orderBy(
        uniqBy(filter(this.currentUser.apprenticeships || [], a => a.manuallyEndedDate === null && !!a.company), 'company.id'),
        o => o.fromDate, 'desc'
      )
        .map(apprenticeship => apprenticeship.company.name || '')

      return `${this.$t('welcome.subTitle')} ${companyNames.join(', ')}`;
    },

    instructorOptions() {
      return [
        {
          user: "isInstructor",
          route: { name: "InstructorEbooks", params: { id: this.currentUser.id } },
          actionIcon: "$sl-ebook",
          title: this.$t("labels.my-book"),
          cssClass: "v-step-22",
        },
        {
          user: "isInstructor",
          route: {
            name: "CompanyInstructorApprentices",
            params: { id: this.currentUserId },
          },
          actionIcon: "$sl-apprentices",
          title: this.$t("labels.my-apprentice"),
          cssClass: "v-step-23",
        },
      ];
    },

    filteredInstructorOptions() {
      const ret = []
      const isInstructorActive = Boolean(this.currentUser?.apprenticeships.length)
      const instructorHasBooks = this.currentUser?.books.length

      if( isInstructorActive )
        ret.push(this.instructorOptions[1])

      if( instructorHasBooks ) 
        ret.push(this.instructorOptions[0])

      return ret
    },

    apprenticeOptions() {
      return [
        {
          user: "isApprentice",
          route: { name: "ApplicationStart", params: { setStep: 0 } },
          actionIcon: "$sl-apprentice-application",
          title: this.$t("labels.application"),
        },
      ];
    },

    hasQualificationTime() {
      return !!this.currentUser?.educations?.some(o => o.qualificationTime)
    },
    
    hasCertificates() {
      return this.currentUser?.educations?.some(o => o.basicEducationCertificate) || !!this.currentUser?.educations?.length
    },

    actionItems() {
      const items = []

      if (this.hasQualificationTime) {
        items.push({
          label: this.$t('labels.my-qualifying-time'),
          icon: '$sl-stairs-ascend',
          action: () => {
            this.$nextTick(() => {
              this.$router.push({
                name: 'PersonQualifyingTime',
                params: { id: this.currentUser.id }
              })
            })
          }
        })
      }

      if (this.hasCertificates) {
        items.push({
          label: this.$t('labels.qualifications'),
          icon: '$sl-trade-certificate',
          action: () => {
            this.$nextTick(() => {
              this.$router.push({
                name: 'PersonQualifications'
              })
            })
          }
        })
      }

      if (
        this.isLoggedIn &&
        this.isRegistered &&
        !this.isCompanyUser(0)
      ) {
        items.push({
          label: this.$t('labels.application'),
          icon: '$sl-apprentice-application',
          badge: this.companyApplicationTotal,
          action: () => {
            this.navigateToApplication()
          }
        })

        items.push({
          label: this.$t('labels.additional-occupation'),
          icon: '$sl-add',
          action: () => {
            this.navigateToApplication({ 'show-popup': 1 })
          }
        })

        items.push({
          label: this.$t('labels.change-company'),
          icon: '$sl-change-company',
          action: () => {
            this.navigateToApplication()
          }
        })
      }

      return items
    }
  },

  watch: {
    toConfirmByCompanyOrderStateId: {
      handler(id) {
        if ( id > 0 ) this.getCompanyOrders()
      },
      immediate: true
    },

    toConfirm(value) {
      bus.$emit('to-confirm', value)
    },

    toApproveForCompany(value) {
      bus.$emit('to-approve-for-company', value);
    },

    currentUser: {
      immediate: true,
      handler(user) {
        if (!user) return

        const consent = getConsent()

        if (consent === null) {
          return
        }

        const allowAnalytics = consent === 'accepted'

        if (user.allowAnalytics === allowAnalytics) return

        API.updatePerson({
          data: {
            ...user,
            allowAnalytics
          }
        })
          .then(res => {
            return this.updateCurrentUserData(res.data)
          })
          .catch(() => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      }
    }
  },

  created() {
    Promise.all([
      this.init(),
      this.getInstructions(),
      this.showConfirmPhone(),
      this.fetchPersonDetails()
    ])
  },

  mounted() {
    this.$scrollToTop();
    this.initTour();
  },

  methods: {
    get,
    find,
    
    ...mapActions("application", ["setCurrentStep"]),
    ...mapActions("currentuser", ["setCurrentUser", "updateCurrentUserData"]),
    
    navigateToApplication(query = null) {
      this.$nextTick(() => {
        this.$router.push({ name: 'ApplicationStart', params: { setStep: 0 }, query });
      });
    },
    
    /**
     * @vuese
     * Used to get list of applications that need to be approved and get company distance order for each employements
     * @arg called search criteries as asrgument
     */
    init() {

      //console.log('LoggedIn - init::', this.currentUser)

      if (this.currentUser && this.currentUser.id) {
        this.currentUserId = this.currentUser.id;
      }

      if (
        this.currentUserId &&
        (
          this.isCompanyEducationResponsible(0) ||
          this.isDistanceEducationAdministrator(0) ||
          this.isDepartmentAdministrator(0) ||
          this.isAdministrator ||
          this.isApprentice
        )
      ) {

        let type = 'received'

        if (this.isApprentice) {
          type = 'own'
        }

        API.listApplications({
          search: "",
          type: type,
          pageSize: 500,
        })
          .then((response) => {

            this.toApproveForCompany = response.data.toApproveForCompany

          })
          .catch((error) => {
            console.log("There was an error:", error);
          });
      }
    },

    getCompanyOrders() {
      let promises = []
      const employments = get(this, 'currentUser.employments', [])

      employments.forEach(employment => {
        const isAdmin = this.isDistanceEducationAdministrator(0) || this.isDepartmentAdministrator(0) || this.isAdministrator

        if( isAdmin && !this.showOrderWarning ) this.getCompanyDistanceOrders(employment.companyId)

        promises.push(
          API.getCompanyOrders(employment.companyId, [this.toConfirmByCompanyOrderStateId])
          .then(({ data }) => {
            const filter = ({ type, stateId }) => ['DistanceOrder', 'ExtensionOrder'].includes(type) && stateId === 1
            return { companyId: employment.companyId, count: data.rows.filter(filter).length }
          })
          .catch((error) => {
            console.log("There was an error:", error.response);
            return 0
          })
        )
      })

      return Promise.all(promises).then(results => {
        this.toConfirm = results.reduce((acc, { companyId, count }) => {
          acc[companyId] = count
          return acc
        }, {})
      })
    },

    async fetchPersonDetails() {
      try {
        if ( !get(this, 'currentUser.id', null) || !get(this, 'currentUser.imitatingUser.userrole.isAdmin', false) ) return
        const { data } = await API.getPerson(this.currentUser.id)
        this.setCurrentUser(data)
      } catch (error) {
        console.log(`Error while fetching person details =>> ${ error }`);
      }
    },
    
    showConfirmPhone(){
      if(new SugarDate.Date(this.$cookies.get('confirmPhoneDate' + this.currentUser.id)).isAfter(new SugarDate.Date().addMonths(-6).raw)==false)
        this.confirmPhoneModal = true
    },
    confirmPhone(){
      //Set/update the cookie with the userId for 6 montsh
      this.$cookies.set("confirmPhoneDate" + this.currentUser.id, new SugarDate.Date().format("{yyyy}-{MM}-{dd}").raw, '6m')
      this.confirmPhoneModal = false
    },
    getInstructions() {
      API.getInstructions()
        .then(({data}) => {
          const commitedDate = data.committedAt
          const lastReadInstructions = this.currentUser.readInstructionsOn
          if (lastReadInstructions) {
            this.shouldReadInstructions = new SugarDate.Date(commitedDate).isAfter(lastReadInstructions).raw
          }
          else
            this.shouldReadInstructions=true
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    /**
     * @vuese
     * Used to start the Tour, if user is administrator or instructor.
     * The guide will start automatic if it is the first time logged in for admin/instructor.
     */
    initTour() {
      if (this.isAdministrator) {
        this.roleList.push(AVAILABLE_ROLES_TOUR.admin);
      }
      if (this.isInstructor(0)) {
        this.roleList.push(AVAILABLE_ROLES_TOUR.instructor);
      }

      if (!this.roleList.length) return

      if (!(this.currentUser.firstLogin && this.currentUser.firstLogin == true || this.guideStart == true)) return

      this.currentUser.firstLogin = false;
      this.setCurrentUser(this.currentUser);

      if (this.roleList.length === 1) {
        this.initTourSteps(this.roleList[0]);
        this.$nextTick(() => {
          this.$tours["myTour"].start();
          this.$nextTick(() => this.expandGroupForTourStep(0)) // expand for first step
        })
      } else {
        this.showRoleDialog = true;
      }
    },

    onRoleConfirm(role){
      this.initTourSteps(role);
      this.showRoleDialog = false;
      this.$nextTick(() => { this.$tours["myTour"].start(); })
    },

    getCompanyDistanceOrders(companyId) {
      if (companyId) {
        API.getCompanyDistanceOrders(companyId)
          .then((res) => {
            this.orders = res.data;

            let find= res.data.find(r => (r.stateId === 1 && r.latestApprovalDate && r.profession && r.profession.daysUntilOrderApproval && (r.profession.daysUntilOrderApproval)>0  && (SugarDate.Date(r.latestApprovalDate).daysFromNow() < Number(r.profession.daysUntilOrderApproval)/2 )))

            if(find)
              this.showOrderWarning=true
            if (this.$route.params.distance_order_id) {
              let o = find(this.orders, [
                "id",
                Number(this.$route.params.distance_order_id),
              ]);
              o ? (this.order = o) : (this.order = {});
            }
          })
          .catch((error) => {
            console.log("There was an error:", error.res);
          });
      }
    },
    /**
     * @vuese
     * Used to init the tour steps
     */
    initTourSteps(role) {
      this.steps = []
      var userSteps = []
      if (role === AVAILABLE_ROLES_TOUR.admin) {
        userSteps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      } else if (role === AVAILABLE_ROLES_TOUR.instructor) {
        userSteps = [21, 22, 23, 24, 25, 26, 27]
      }

      // These step numbers target items inside collapsible menu panels
      const menuSteps = [4, 5, 6, 7, 8, 9, 10, 11, 24, 25]

      if (userSteps.length > 0) {
        for (let i = 0; i < userSteps.length; i++) {
          const stepNumber = userSteps[i]
          this.steps.push({
            target: '.v-step-' + String(stepNumber),
            header: {
              title: this.$t(`tour.title${String(stepNumber)}`),
            },
            content: this.$t(`tour.text${String(stepNumber)}`),
            params: {
              placement: menuSteps.includes(stepNumber) ? 'right' : 'top',
            },
          })
        }
      }
    },

    getCompanyMenuItems(employment) {
      const companyId = employment.companyId
      const items = []

      const settingsGroup = {
        icon: '$sl-settings',
        label: this.$t('labels.company-settings'),
        tourClass: 'v-step-4',
        children: []
      }

      if (this.isCompanyUser(companyId)) {
        settingsGroup.children.push({
          to: {name: 'CompanyWorkplaces', params: {id: companyId}},
          icon: '$sl-workplace',
          label: this.$t('labels.workplaces'),
          tourClass: 'v-step-4 v-step-24'
        })
      }

      if ((this.isAdministrator || this.isDepartmentAdministrator(companyId)) && this.hasDepartments(companyId)) {
        settingsGroup.children.push({
          to: {name: 'CompanyDepartments', params: {id: companyId}},
          icon: '$sl-departments',
          label: this.$t('company.sections'),
          tourClass: 'v-step-5'
        })
      }

      if (settingsGroup.children.length) {
        items.push(settingsGroup)
      }

      const staffGroup = {
        icon: '$sl-staff',
        label: this.$t('labels.staff'),
        children: [],
        onClick: (this.isAdministrator || this.isDepartmentAdministrator(companyId) || this.isCompanyEducationResponsible(companyId))
          ? () => this.$router.push({name: 'CompanyEmployees', params: {id: companyId}}).catch(() => {})
          : null
      }

      if (this.isDepartmentAdministrator(companyId) || this.isCompanyEducationResponsible(companyId) || this.isAdministrator) {
        staffGroup.children.push({
          to: {name: 'CompanyEmployeesPermissions', params: {id: companyId}},
          icon: '$sl-permissions',
          label: this.$t('labels.roles'),
          tourClass: 'v-step-5'
        })
      }

      if (this.isDistanceEducationAdministrator(companyId) || this.isDepartmentAdministrator(companyId) || this.isAdministrator) {
        staffGroup.children.push({
          to: {name: 'CompanyInstructors', params: {id: companyId}},
          icon: '$sl-instructor',
          label: this.$t('labels.instructors'),
          tourClass: 'v-step-9'
        })
      }

      if (this.isDepartmentAdministrator(companyId) || this.isDistanceEducationAdministrator(companyId) || this.isAdministrator) {
        staffGroup.children.push({
          to: {name: 'CompanyExemptions', params: {id: companyId}},
          icon: '$sl-single-neutral-actions-check',
          label: this.$t('labels.exemption')
        })
      }

      if (this.isCompanyEducationResponsible(companyId) || this.isDistanceEducationAdministrator(companyId) ||
          this.isDepartmentAdministrator(companyId) || this.isAdministrator) {
        staffGroup.children.push({
          to: {name: 'CompanyYUA', params: {id: companyId}},
          icon: '$sl-yua',
          label: this.$t('labels.yua'),
          tourClass: 'v-step-8'
        })
      }

      if (staffGroup.children.length || staffGroup.onClick) {
        items.push(staffGroup)
      }

      const apprenticesGroup = {
        icon: '$sl-apprentice',
        label: this.$t('labels.apprentices'),
        children: [],
        badge: (this.toApproveForCompany[employment.companyId]?.length ?? 0) + (this.toConfirm[employment.companyId] ?? 0)
      }

      if (this.isCompanyEducationResponsible(companyId) || this.isDistanceEducationAdministrator(companyId) ||
          this.isDepartmentAdministrator(companyId) || this.isAdministrator) {
        apprenticesGroup.children.push({
          to: {name: 'CompanyApprenticesOverview', params: {id: companyId}},
          icon: '$sl-apprentices',
          label: this.$t('labels.apprentices_overview')
        })

        apprenticesGroup.children.push({
          to: {name: 'CompanyApprentices', params: {id: companyId}},
          icon: '$sl-apprentice',
          label: this.$t('labels.apprentices_all_btn'),
          tourClass: 'v-step-10'
        })

        apprenticesGroup.children.push({
          to: {name: 'CompanyApplications', params: {id: companyId}},
          icon: '$sl-apprentice-application',
          label: this.$t('labels.applications'),
          tourClass: 'v-step-6',
          badge: this.toApproveForCompany && this.toApproveForCompany[employment.companyId]
            ? this.toApproveForCompany[employment.companyId].length
            : 0
        })
      }

      const ordersSubGroup = {
        label: this.$t('labels.distance-orders'),
        subGroup: true,
        children: [],
        badge: this.toConfirm[employment.companyId] || 0
      }

      if (this.isDistanceEducationAdministrator(companyId) || this.isDepartmentAdministrator(companyId) || this.isAdministrator) {
        ordersSubGroup.children.push({
          to: {name: 'CompanyDistanceOrders', params: {companyId}},
          icon: '$sl-approve-distance-order',
          label: this.$t('labels.distance-orders-type.basic-education'),
          tourClass: 'v-step-11',
          badge: this.toConfirm[employment.companyId] || 0
        })
      }

      if (this.isCompanyUser(companyId)) {
        ordersSubGroup.children.push({
          to: {name: 'CompanyOrderCardStart', params: {id: companyId}},
          icon: '$sl-invitation',
          label: this.$t('labels.person-orders-machine')
        })
      }

      if (this.isCompanyUser(companyId)) {
        apprenticesGroup.children.push({
          to: {name: 'CreateCompanyApplications', params: {id: companyId, setStep: 0}},
          icon: '$sl-add-application',
          label: this.$t('labels.add-new-applications'),
          tourClass: 'v-step-7 v-step-25'
        })
      }

      if (this.isAdministrator || this.isDepartmentAdministrator(companyId) || this.isCompanyEducationResponsible(companyId)) {
        apprenticesGroup.children.push({
          to: {name: 'CompanyPausedPersons', params: {id: companyId}},
          icon: '$sl-pause',
          label: this.$t('labels.pause')
        })
      }

      if (ordersSubGroup.children.length) {
        apprenticesGroup.children.push(ordersSubGroup)
      }

      if (apprenticesGroup.children.length) {
        items.push(apprenticesGroup)
      }

      return items
    },

    expandGroupForTourStep(stepIndex) {
      const step = this.steps[stepIndex]
      if (!step) return

      const targetClass = step.target.split(' ')[0].replace('.', '')

      const hasClass = (tourClass, target) => {
        if (!tourClass) return false
        return tourClass.split(' ').some(c => c === target)
      }

      const hasMenuTarget = this.currentUser.employments.some((employment) => {
        return this.getCompanyMenuItems(employment).some((menuItem) => {
          if (!menuItem.children || !menuItem.children.length) return false
          return menuItem.children.some((child) => {
            if (child.subGroup) {
              return child.children?.some(sub => hasClass(sub.tourClass, targetClass))
            }
            return hasClass(child.tourClass, targetClass)
          })
        })
      })

      if (!hasMenuTarget) return

      this.currentUser.employments.forEach((employment, i) => {
        const menuItems = this.getCompanyMenuItems(employment)

        menuItems.forEach((menuItem, itemIndex) => {
          const refKey = `listGroup-${i}-${itemIndex}`
          const groupRef = this.$refs[refKey]
          const group = Array.isArray(groupRef) ? groupRef[0] : groupRef
          if (group) group.isActive = false

          if (!menuItem.children || !menuItem.children.length) return

          let parentMatch = false

          menuItem.children.forEach((child, childIndex) => {
            const subRefKey = `listGroup-${i}-${itemIndex}-${childIndex}`
            const subGroupRef = this.$refs[subRefKey]
            const subGroup = Array.isArray(subGroupRef) ? subGroupRef[0] : subGroupRef
            if (subGroup) subGroup.isActive = false

            if (child.subGroup) {
              if (!child.children || !child.children.length) return

              const inSubGroup = child.children.some(sub => hasClass(sub.tourClass, targetClass))

              if (inSubGroup) {
                parentMatch = true
                if (subGroup) subGroup.isActive = true
              }
            } else if (hasClass(child.tourClass, targetClass)) {
              parentMatch = true
            }
          })

          if (parentMatch) {
            if (group) {
              group.isActive = true
              this.$nextTick(() => {
                setTimeout(() => {
                  const el = document.querySelector(step.target)
                  if (el) {
                    el.scrollIntoView({ behavior: 'instant', block: 'center' })
                    this.positionTourStep(step.target)
                  }
                }, 350)
              })
            }
          }
        })
      })
    },

    onTourNext(tour) {
      const nextStep = tour.currentStep + 1
      tour.nextStep()
      this.$nextTick(() => {
        this.expandGroupForTourStep(nextStep)
      })
    },

    onTourPrevious(tour) {
      const prevStep = tour.currentStep - 1
      tour.previousStep()
      this.$nextTick(() => {
        this.expandGroupForTourStep(prevStep)
      })
    },

    // Call this wherever you start the tour (e.g. a "Start Tour" button)
    startTour() {
      this.$tours.myTour.start()
      this.$nextTick(() => this.expandGroupForTourStep(0))
    },

    positionTourStep(stepTarget) {
      const tourEl = document.querySelector('.v-step')
      if (!tourEl) return

      const el = document.querySelector(stepTarget)

      if (!el) {
        tourEl.style.top = '50%'
        tourEl.style.left = '50%'
        tourEl.style.transform = 'translate(-50%, -50%)'
        tourEl.style.bottom = 'auto'
        tourEl.style.right = 'auto'
        return
      }

      const rect = el.getBoundingClientRect()
      const tourHeight = tourEl.offsetHeight
      const tourWidth = tourEl.offsetWidth
      const offset = 8
      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth

      // Try below first
      let top = rect.bottom + offset
      let left = rect.left

      // If popup goes below viewport, position above instead
      if (top + tourHeight > viewportHeight) {
        top = rect.top - tourHeight - offset
      }

      // If it still goes above viewport, just center it vertically
      if (top < 0) {
        top = (viewportHeight - tourHeight) / 2
      }

      // Make sure it doesn't go off the right edge
      if (left + tourWidth > viewportWidth) {
        left = viewportWidth - tourWidth - offset
      }

      // Make sure it doesn't go off the left edge
      if (left < 0) left = offset

      tourEl.style.position = 'fixed'
      tourEl.style.top = `${top}px`
      tourEl.style.left = `${left}px`
      tourEl.style.transform = 'none'
      tourEl.style.bottom = 'auto'
      tourEl.style.right = 'auto'
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-item {
  flex: 1 1 0;
  width: 0;
}
</style>
